import React from 'react';
import { useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';
import { aimToObject } from '../../controls/helpers';
import { fiderIcon, ktpIcon, pillarIcon, projectStatusOreolIcon } from '../../layers/icons';
import { Box, Typography } from '@mui/material';
import L from 'leaflet';

const RelatedObjectsPanel = ({ mark, darkMode = false }) => {
    console.log(mark)
    const map = useMap();
    const { feedingSubstations, transformers, pillars, fiders } = useSelector(state => state.state.electricity);

    const relatedObjects = [];

    const getRelatedFeedingSubstation = () => {
        const fs = feedingSubstations.find(fs => fs.fid.toString() === mark.ps_id.toString());
        if (fs) {
            relatedObjects.push(
                <Box key={fs.fid} sx={{ display: 'flex', flexDirection: 'row', p: 0, gap: 1, cursor: 'pointer', alignItems: 'center' }} onClick={() => aimToObject(map, fs)}>
                    <Box sx={{ width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
                        <svg fill="#000000" width="18px" height="18px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24">
                            <path d="M21.9,19.3l-9-15.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.3-1.1-0.2-1.4,0.3l-9,15.6C2,19.4,2,19.6,2,19.8c0,0.6,0.4,1,1,1h18c0.2,0,0.3,0,0.5-0.1C22,20.4,22.1,19.8,21.9,19.3z"
                                fill="#96CD93" stroke="#40A438" strokeWidth="2px" opacity="0.9" />
                        </svg>
                    </Box>
                    <Typography sx={{ fontSize: '0.8rem', m: '0 !important', flex: 1 }}>{fs.name}</Typography>
                </Box>
            );
        }
    }

    const getRelatedTransformer = () => {
        const tp = transformers.find(p => p.fid.toString() === mark.tp_id.toString());
        if (tp) {
            console.log(tp)
            relatedObjects.push(
                <Box key={tp.fid} sx={{ display: 'flex', flexDirection: 'row', p: 0, gap: 1, cursor: 'pointer', alignItems: 'center' }} onClick={() => aimToObject(map, tp)}>
                    <Box sx={{ width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
                        <Box sx={{ position: 'relative', display: 'flex', width: 36, height: 36, justifyContent: 'center', alignItems: 'center' }}>
                            <Box style={{ position: 'absolute' }}>
                                {ktpIcon(tp.accounting ? 'accounting' : 'default', 20, 20)}
                            </Box>
                            {['2', '3', '4', '7'].includes(tp.layer) ? (
                                <Box style={{ position: 'absolute' }}>
                                    {projectStatusOreolIcon('ktp', Number(tp.layer), 36)}
                                </Box>
                            ) : null}
                        </Box>
                    </Box>
                    <Typography sx={{ fontSize: '0.8rem', m: '0 !important', flex: 1 }}>{tp.name}</Typography>
                </Box>
            );
        }
    }

    const getRelatedPillars = () => {
        let  p = null
        if (mark.type.includes('transformer')) p = pillars.filter(p => p.tp_id?.toString() === mark.fid.toString()).filter(f => f)
        if (mark.type.includes('fider')) p = pillars.filter(p => mark.connected?.find(c => c && c.type === 'pillar' && Number(c.id) === Number(p.fid))).filter(f => f)
        if (p && p.length > 0) {
            p.sort((a, b) => parseInt(a.draft_num) - parseInt(b.draft_num)).forEach(p => {
                const type = p.status
                relatedObjects.push(

                    <Box key={`pillar_${p.fid}`} sx={{ display: 'flex', flexDirection: 'row', p: 0, gap: 1, cursor: 'pointer', alignItems: 'center' }} onClick={() => aimToObject(map, p)}>
                        <Box sx={{ width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
                            <Box sx={{ position: 'relative', display: 'flex', width: 28, height: 28, justifyContent: 'center', alignItems: 'center' }}>
                                <Box style={{ position: 'absolute' }}>
                                    {pillarIcon(p.type, p.status, p.material_type, p.supports_count, 12)}
                                </Box>
                                {[2, 3, 4, 7].includes(Number(p?.layer)) ? (
                                    <Box style={{ position: 'absolute' }}>
                                        {projectStatusOreolIcon('pillar', Number(p.layer), 28)}
                                    </Box>
                                ) : null}
                            </Box>
                        </Box>
                        <Typography sx={{ fontSize: '0.8rem', m: '0 !important', flex: 1 }}>{p.name}</Typography>
                    </Box>

                )
            })
        }
    }

    const getRelatedFiders = () => {

        const typesMap = {
            'fider330': 'fider330',
            'fider110': 'fider110',
            'fider35': 'fider35',
            'fider10': 'fider_sip_3',
            'fider10_04': 'fider_sip_3',
            'fider10-04': 'fider_sip_3',
            'fider6': 'fider_sip_3',
            'fider04': 'fider_sip_2'
        }
        let f = null
        if (mark.type.includes('transformer')) {
            f = fiders.filter(f => f.tp_id?.toString() === mark.fid.toString()).filter(f => f)
        }
        if (mark.type.includes('pillar')) {
            f = fiders.filter(f => f.connected?.find(c => c && c.type === 'pillar' && Number(c.id) === Number(mark.fid))).filter(f => f)
        }
        if (f && f.length > 0) {
            f.forEach(f => {
                relatedObjects.push(
                    <Box key={`fider_${f.id}`} sx={{ display: 'flex', flexDirection: 'row', p: 0, gap: 1, cursor: 'pointer', alignItems: 'center' }} onClick={() => {
                        const line = new L.Polyline(f.coordinates, {
                            color: '#00A2E8',
                            weight: 16,
                            opacity: 0.5,
                            fillOpacity: 0.5,
                            fillRule: 'evenodd',
                            // pane: 'shadowPane',
                            interactive: false

                        },

                        )
                        line.addTo(map).bringToBack()
                        setTimeout(() => {
                            line.remove()
                        }, 6000)
                    }}>
                        <Box sx={{ width: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
                            {fiderIcon(typesMap[f.type] || 'fider_sip_2', 24)}
                        </Box>
                        <Typography sx={{ fontSize: '0.8rem', m: '0 !important', flex: 1 }}>{f.layer}</Typography>
                    </Box>
                )
            })
        }
    }




    switch (mark.type) {
        case 'transformer':
        case 'transformers':
            if (mark.ps_id) getRelatedFeedingSubstation()
            getRelatedPillars()
            getRelatedFiders()
            break;
        case 'pillar04':
        case 'pillar10':
        case 'pillar04-10':
            if (mark.ps_id) getRelatedFeedingSubstation()
            if (mark.tp_id) getRelatedTransformer()
            getRelatedFiders()
            break;
        case 'fider330':
        case 'fider110':
        case 'fider35':
        case 'fider10':
        case 'fider10_04':
        case 'fider10-04':
        case 'fider6':
        case 'fider04':
            if (mark.ps_id) getRelatedFeedingSubstation()
            if (mark.tp_id) getRelatedTransformer()
            getRelatedPillars()
            break;
        default:
            break;
    }


    if (relatedObjects.length === 0) {
        return (
            <div style={{ padding: '10px', textAlign: 'center', color: darkMode ? '#999' : '#666' }}>
                Связанные объекты не найдены
            </div>
        );
    }

    return (
        <div style={{ maxHeight: '300px', overflowY: 'auto', scrollbarWidth: 'thin' }}>
            {relatedObjects}
        </div>
    );
};

export default RelatedObjectsPanel;
